module.exports = __webpack_public_path__ + "static/img/详情页主图1.18b8e40d.png";